@if (initialized()) {
  <div class="page">
    <div class="container-fluid container-site pt-3">
      <div class="row py-5">
        <div class="col text-center">
          <h1 class="h2">Archivo de la revista digital Liber</h1>
        </div>
      </div>

      <div class="row pt-2 g-4">
        @for (item of data(); track item.number) {
          <div class="col-12 col-sm-6 col-md-3">
            <div class="p-3 magazine-item h-100">
              <div class="magazine-item-header text-muted mb-2">
                {{ item.title }}
              </div>

              <img
                [src]="item.cover | assetFormatter"
                class="img-fluid"
                [alt]="item.title"
              />

              <div class="text-center">
                <div class="mb-3 pt-3">
                  <a
                    class="btn btn-light border btn-md"
                    [routerLink]="['/liber', item.slug]"
                  >
                    Ver todo el contenido
                  </a>
                </div>

                @if (item.pdf && item.pdf.length > 0) {}
                <div>
                  <a
                    [href]="item.pdf[0].download_link | assetFormatter"
                    class="btn btn-primary btn-md"
                    target="_blank"
                    rel="noopener"
                  >
                    Ver Liber en PDF
                  </a>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
